(function () {
  function enforceValidSavings(select) {
    var option = select.options[select.selectedIndex];
    var product = select.closest('.product--outer');

    if (!option || !product) return;

    var price = Number(option.dataset.variantPrice);
    var compareAtPrice = Number(option.dataset.variantCompareAtPrice);
    var savings = compareAtPrice - price;
    var hasValidSavings = compareAtPrice > price && savings > 0;

    product.querySelectorAll('[data-badge-sales]').forEach(function (badge) {
      if (!hasValidSavings) badge.style.display = 'none';
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-variants]')) return;

    window.setTimeout(function () {
      enforceValidSavings(event.target);
    }, 0);
  });

  window.addEventListener('shopify-variants:switch-variant', function (event) {
    var variant = event.detail && event.detail.variant;

    if (!variant) return;

    document.querySelectorAll('[data-variants]').forEach(function (select) {
      if (String(select.value) !== String(variant.id)) return;

      window.setTimeout(function () {
        enforceValidSavings(select);
      }, 0);
    });
  });
}());
